(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/analyze/assets/event-analyses.js') >= 0) return;  svs.modules.push('/components/sport/analyze/assets/event-analyses.js');
"use strict";


const {
  ReactIcon
} = svs.ui;
const {
  EventAnalysis
} = svs.component.analyze;
const EventAnalyses = _ref => {
  let {
    analyses,
    isExpanded,
    onToggleExpand,
    authors,
    branding,
    eventTypeId,
    sportType
  } = _ref;
  return React.createElement("li", {
    className: "event-analyses"
  }, React.createElement("div", {
    className: "pg_analyse__event"
  }, React.createElement("div", {
    className: "pg_analyse__event__title"
  }, React.createElement("span", {
    className: "margin-right"
  }, analyses[0].eventNumber), analyses[0].title), analyses.map((matchAnalysis, index) => {
    if (!authors[index].selected) {
      return null;
    }
    return React.createElement(EventAnalysis, {
      branding: branding,
      eventTypeId: eventTypeId,
      isExpanded: isExpanded,
      key: matchAnalysis.id,
      matchAnalysis: matchAnalysis,
      sportType: sportType
    });
  })), React.createElement("div", {
    className: "event-analyses-divider"
  }), React.createElement("div", {
    className: "event-analyses-expander",
    onClick: () => {
      onToggleExpand(analyses[0].gameInfo.sportEvents[0]);
    }
  }, React.createElement(ReactIcon, {
    icon: isExpanded ? 'menu-up' : 'menu-down',
    size: "100"
  })));
};
setGlobal('svs.component.analyze.EventAnalyses', EventAnalyses);

 })(window);